import { PRICE_CURRENCY_int, PRICE_CURRENCY_int__float, PRICE_FORFREE } from 'mk/autogenerated/translations/formatters.1f00a585fe0c97c92521cd6375190c03'
import { interpolate } from 'mk2/services/i18n';

export function formatThousands(numberToFormat: number | string, separator: string = '') {
    if (numberToFormat === undefined || numberToFormat === null) {
        return '';
    }

    return numberToFormat.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
}

export function formatPrice(price: string | number, displayZero: boolean = false) {
    // we deal with strings here, because decimal values cannot be correctly represented in javascript
    if ((price === null) || (price === undefined)) {
        return '';
    }

    const priceFloat = typeof price === 'string' ? parseFloat(price) : price;
    if (!displayZero && priceFloat === 0) {
        return PRICE_FORFREE;
    }

    const parts = priceFloat.toFixed(2).split('.');
    if (parts[1] === '00') {
        return interpolate(PRICE_CURRENCY_int, {int: parts[0]});
    } else {
        return interpolate(PRICE_CURRENCY_int__float, {int: parts[0], float: parts[1]});
    }
}
